import { OperationType } from 'components/RecordsListView/constants';

// eslint-disable-next-line import/prefer-default-export
export const PLAN_TO_OPERATION_MODAL_CONTENT = {
  [OperationType.APPLICATION]: {
    title: 'Create Application from Plan',
    description: 'Select the product(s) you want to include in your Application'
  },
  [OperationType.WORK_ORDER]: {
    title: 'Create Work Order from Plan',
    description: 'Select the product(s) you want to include in your Work Order'
  }
};
